// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomThreadPostCreate
 */
export interface ClassroomThreadPostCreate {
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadPostCreate
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadPostCreate
     */
    thread: string;
    /**
     * 
     * @type {number}
     * @memberof ClassroomThreadPostCreate
     */
    replyTo?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadPostCreate
     */
    classroom: string;
}

export function ClassroomThreadPostCreateFromJSON(json: any): ClassroomThreadPostCreate {
    return {
        'content': json['content'],
        'thread': json['thread'],
        'replyTo': !exists(json, 'reply_to') ? undefined : json['reply_to'],
        'classroom': json['classroom'],
    };
}

export function ClassroomThreadPostCreateToJSON(value?: ClassroomThreadPostCreate): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'content': value.content,
        'thread': value.thread,
        'reply_to': value.replyTo,
        'classroom': value.classroom,
    };
}


